import type { DevicePlanResponse } from "@somewear/api";
import { DeviceRecord } from "@somewear/api";
import { DeviceActivationStateTypeMap } from "@somewear/api/src/proto/api/device_pb";
import {
	ButtonFunction,
	InmarsatLeaseType,
	type RadioBandwidthMap,
	RadioMode,
	type RadioSpreadFactorMap,
} from "@somewear/api/src/proto/command_public_proto_pb";

import type { ValueOf } from "../common/valueOf";

export interface IDevice extends DeviceRecord.AsObject {
	plan?: DevicePlanResponse.AsObject;
	hasDataUsage?: boolean;
	kbIncluded?: number;
	kbUsed?: number;
	isBorrowed?: boolean;
}

export enum DeviceActivationChange {
	NONE,
	ACTIVATE,
	SUSPEND,
	DISABLE,
}

export interface IQueuedDeviceActivationChange {
	serial: string;
	currentState: DeviceActivationStateTypeMap[keyof DeviceActivationStateTypeMap];
	change: DeviceActivationChange;
}

const NODE_SERIAL_PREFIXES = ["PC0", "RC", "N"];

export function deviceHasNodeSerial(serial?: string) {
	if (!serial) return false;

	return NODE_SERIAL_PREFIXES.some((prefix) => serial.startsWith(prefix));
}

export const getDeviceModelName = (device: Pick<IDevice, "model"> | undefined) => {
	let modelName = "Other";

	switch (device?.model) {
		case DeviceRecord.Model.SWL1: {
			modelName = "Hotspot";
			break;
		}
		case DeviceRecord.Model.SHOUTNANO: {
			modelName = "Shout";
			break;
		}
		case DeviceRecord.Model.NODE: {
			modelName = "Node";
			break;
		}
	}
	return modelName;
};

export enum TrackingIntervalIds {
	ATAK5 = "atak5s",
	ATAK15 = "atak15s",
	ATAK30 = "atak30s",
	ATAK45 = "atak45s",
	ATAK1Min = "atak1min",
	ATAK2Min = "atak2min",
	ATAK5Min = "atak5min",
	ATAK10Min = "atak10min",
	ATAK20Min = "atak20min",
	ATAK30Min = "atak30min",
	ATAK1Hr = "atak1hr",
	OneMin = "oneMin",
	OneSec = "oneSec",
	TwoSec = "twoSec",
	OnFoot = "onFoot",
	Vehicle = "vehicle",
	Custom1 = "custom1",
	Custom2 = "custom2",
}

// export enum RadioFrequencyIds {
// 	AMERICAS1 = "AMERICAS1",
// 	AMERICAS2 = "AMERICAS2",
// 	AMERICAS3 = "AMERICAS3",
// 	EUROPE1 = "EUROPE1",
// }

export enum MeshDataRateIds {
	Low = "low",
	High = "high",
}

export type MeshDataRateParams = {
	spreadFactor: ValueOf<RadioSpreadFactorMap>;
	bandwidth: ValueOf<RadioBandwidthMap>;
};

export enum RadioModeIds {
	NONE = RadioMode.RADIOMODENONE,
	DISABLED = RadioMode.RADIOMODEDISABLED,
	ENABLED = RadioMode.RADIOMODEENABLED,
	// Also Stealth is available but we wont use that.
}

export enum InmarsatLeaseTypeIds {
	NONE = InmarsatLeaseType.INMARSATLEASETYPENONE,
	LAISR = InmarsatLeaseType.INMARSATLEASETYPELAISR,
	LTAC = InmarsatLeaseType.INMARSATLEASETYPELTAC,
}

export enum ButtonFunctionIds {
	NONE = ButtonFunction.BUTTONFUNCTIONNONE,
	SAT = ButtonFunction.BUTTONFUNCTIONSAT,
	TRACKING = ButtonFunction.BUTTONFUNCTIONTRACKING,
	SENSOR = ButtonFunction.BUTTONFUNCTIONSENSOR,
	PTT = ButtonFunction.BUTTONFUNCTIONPTT,
}

export enum MeshKeyMethodVersion {
	UNKNOWN = 0,
	WORKSPACE = 1,
	STAMP = 2,
}
